import { DynamicLayout, formBuilderConstants } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const hashAlgorithms = {
  MD2: 'MD2',
  MD5: 'MD5',
  'SHA-1': 'SHA-1',
  'SHA-256': 'SHA-256',
  'SHA-384': 'SHA-384',
  'SHA-512': 'SHA-512',
};
const encodingAlgorithms = {
  base64: 'Base64',
  hex: 'Hex',
};

const encryptAlgorithms = { openpgp: 'Openpgp' };

const encryptTypes: {} = {
  hash: hashAlgorithms,
  encrypt: encryptAlgorithms,
  encode: encodingAlgorithms,
};

const hash: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'encrypt',
      actionParams: {
        algorithm: '',
        method: '',
        encoding: '',
        strings: [''],
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.algorithm',
    'action.actionParams.encoding',
    'action.actionParams.strings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.algorithm',
        'action.actionParams.encoding',
        'action.actionParams.strings.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const encrypt: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'encrypt',
      actionParams: {
        method: '',
        algorithm: '',
        encoding: '',
        compression: '',
        publicKey: '',
        strings: [''],
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.algorithm',
    'action.actionParams.encoding',
    'action.actionParams.compression',
    'action.actionParams.publicKey',
    'action.actionParams.strings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.algorithm',
        'action.actionParams.encoding',
        'action.actionParams.compression',
        'action.actionParams.publicKey',
        'action.actionParams.strings.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const encode: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'encrypt',
      actionParams: {
        algorithm: '',
        encoding: '',
        method: '',
        strings: [''],
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.algorithm',
    'action.actionParams.encoding',
    'action.actionParams.strings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.algorithm',
        'action.actionParams.strings.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

export const encryption: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'encrypt',
      actionParams: {
        strings: [''],
        algorithm: formBuilderConstants.DEFAULT_SELECT_OPTION_VALUE,
      },
      result: {
        yes: newStepValue,
        no: newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.algorithm',
    'action.actionParams.strings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.algorithm',
        'action.actionParams.strings.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    encoding: {
      type: 'dropdown',
      label: 'Encoding',
      attributes: {
        options: encodingAlgorithms,
        data: false,
      },
      validators: {
        optionSelected: true,
      },
    },
    algorithm: {
      type: 'dropdownGroup',
      label: 'Algorithm',
      attributes: {
        optionsGroup: encryptTypes,
        data: true,
        type: 'group',
      },
      validators: {
        optionSelected: true,
      },
    },
    compression: {
      type: 'text',
      label: 'Compression',
      validators: {
        required: true,
      },
    },
    publicKey: {
      type: 'textarea',
      label: 'Public Key',
      validators: {
        required: true,
      },
    },
    strings: {
      dataType: 'array',
      type: 'text',
      label: '*',
      attributes: {
        add: true,
        header: 'Variable:',
      },
    },
    result: {
      dataType: 'keyValue',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        attributes: {
          // readonly: false
        },
        type: 'next',
        label: 'Point to',
      },
    },
  },
  data: {
    dataPath: 'action.actionParams.algorithm',
    groupPath: 'action.actionParams.method',
    algorithm: {
      hash: hash,
      encrypt: encrypt,
      encode: encode,
    },
  },
};
